import { Moon, Sun } from '@phosphor-icons/react';
import React, { useEffect, useState } from 'react'

const ToggleTheme = () => {

    const [isDarkMode, setIsDarkMode] = useState(localStorage.getItem("theme") === "dark-theme");

    const toggleTheme = () => {
        setIsDarkMode(!isDarkMode);
        const body = document.body;
        if (!isDarkMode) {
            body.classList.add('dark-theme');
            localStorage.setItem("theme", "dark-theme");
        } else {
            body.classList.remove('dark-theme');
            localStorage.setItem("theme", "light-theme");
        }
    };

    useEffect(() => {
        const savedTheme = localStorage.getItem("theme");
        if (savedTheme === "dark-theme") {
            document.body.classList.add('dark-theme');
            setIsDarkMode(true);
        }  else {
            setIsDarkMode(false);
        }
    }, []);

    return (
        <>
            <label className="switch">
                <input type="checkbox" onChange={toggleTheme} checked={isDarkMode} />
                <span className="slider round">
                    <span className="icon sun-icon"><Sun size={17} /></span>
                    <span className="icon moon-icon"><Moon size={17} /></span>
                </span>
            </label>
        </>
    );
}

export default ToggleTheme